import { Checkbox, Space } from 'antd';
import { map } from 'lodash';
import React from 'react';
import { Stack } from 'components/stack/stack';
import { Text } from 'components/text/Text';
import { OfferResponse } from 'logic/api-models/api-models';
import { TutoringType } from 'logic/api-models/tutoring-type';
import { isTutoringTypeEnabled } from 'logic/api-models/tutoring-type.logic';
import { translate, translationKeys } from 'logic/translations/translations.service';
import './TutorClassLocation.less';
import getIsTutoringSchool from 'logic/helpers/isTutoringSchool';

export const TutorClassLocation: React.FC<{
  offer: OfferResponse | undefined;
}> = ({ offer }) => {
  const isTutoringSchool = getIsTutoringSchool(offer);
  return (
    <div>
      <Stack gap={0.5} flow="row">
        <Text color="primary" size={14} strong>
          {translate(translationKeys.offerDetails.classLocation)}
        </Text>
        {map(TutoringType).map((teachingLocation) => {
          const isChecked = isTutoringTypeEnabled(offer?.tutoringType, teachingLocation);
          return (
            <Space key={teachingLocation} direction={'horizontal'}>
              <Checkbox className="teaching-location" checked={isChecked} disabled>
                {translate(isTutoringSchool ? translationKeys.common.instituteTeachingLocation[teachingLocation] : translationKeys.common.teachingLocation[teachingLocation])}
              </Checkbox>
            </Space>
          );
        })}
      </Stack>
    </div>
  );
};
